// extracted by mini-css-extract-plugin
module.exports = {"page":"dynamo-dynamic-page_page__IjAOq","page__body":"dynamo-dynamic-page_page__body__wLELz","page__footer":"dynamo-dynamic-page_page__footer__1Teb8"};